import { __assign, __spreadArray, __read } from 'tslib';
import { ImageAnimationType } from '../../types/animation.esm.js';
import { clearListfromUndefinedOrNull } from '../../utils/misc.esm.js';
import { isElementVisible } from './visibility.esm.js';

var ANIMATION_CLASSNAME_BASE = 'animation';
var ANIMATION_CLASSNAME_SELECTOR = "[class*=\"".concat(ANIMATION_CLASSNAME_BASE, "\"]");
var VISIBLE_CLASSNAME_TIMEOUT_DELAY = 200;
var ANIMATION_CLASSNAME_FILENAME = 'transitions--';
var animationTypeList = function (classes) { return ({
    'fade-down': {
        end: classes.fadeDownEnd,
        start: classes.fadeDownDefault,
    },
    'fade-in': {
        end: classes.fadeInEnd,
        start: classes.fadeInDefault,
    },
    'fade-in-left': {
        end: classes.fadeInLeftEnd,
        start: classes.fadeInLeftDefault,
    },
    'fade-in-right': {
        end: classes.fadeInRightEnd,
        start: classes.fadeInRightDefault,
    },
    'fade-up': {
        end: classes.fadeUpEnd,
        start: classes.fadeUpDefault,
    },
}); };
var getClassname = function (animationType) { return "".concat(ANIMATION_CLASSNAME_BASE, "-").concat(animationType); };
var fadeInAnimationClassname = getClassname(ImageAnimationType.FadeIn);
// extract the (ANIMATION_CLASSNAME_BASE + '-' + TAnimation name) from the list of classnames we get from element's classname prop
var getClassnameType = function (classList, classes) {
    // match and get the classname that starts with ANIMATION_CLASSNAME_BASE
    var animation = __spreadArray([], __read(classList), false).find(function (className) { return className.startsWith(ANIMATION_CLASSNAME_BASE); });
    if (!animation)
        return;
    // then remove the ANIMATION_CLASSNAME_BASE and get clean TAnimation name to use as a type and get the classname
    var animationClass = animation.substring(ANIMATION_CLASSNAME_BASE.length).substring(1);
    var animationType = animationTypeList(classes);
    return animationType[animationClass];
};
// eslint-disable-next-line no-undef
var getElementList = function (elements, classes) {
    return clearListfromUndefinedOrNull(Array.from(elements, function (node) {
        //get the appropriate initial class based of the animation type we get from classname
        var animationClass = getClassnameType(node.classList, classes);
        if (!animationClass)
            return;
        return {
            animated: false,
            animationClass: animationClass,
            node: node, //actual element data
        };
    }));
};
/**
 * @param elementsList - list of elements that requires animation classes to be attached
 * @param handleClassnameFunc - handle element. May attach the initial-position(start) class or attach visible(end)-animation class
 */
var callWithVisible = function (elementsList, handleClassnameFunc) {
    //filter out all elements
    return elementsList
        .filter(function (el) { return !el.animated; })
        .map(function (element) {
        var rect = element.node.getBoundingClientRect();
        // check if the element is visible in the viewport
        var isVisible = isElementVisible(rect);
        //handle the element. May attach the initial(start)-animation class or attach visible(end)-animation class
        handleClassnameFunc(element, isVisible);
        return __assign(__assign({}, element), { 
            //finish animation is always triggered when the element is visible
            animated: isVisible });
    });
};
/**
 * @param item - the element that is lready is visible in the viewport
 * @param className - the classes we can use to attach the visible(end) animation
 */
var addClassnameForVisible = function (item, endClassName) {
    // set timeout so the animation is visible when the element is shown
    setTimeout(function () {
        item.node.classList.add(endClassName);
    }, VISIBLE_CLASSNAME_TIMEOUT_DELAY);
};
/**
 *
 * @param className - the classname we check if it already has the animation classnames attached
 * Used for elements that were added by the hook, so we don't have duplicates
 */
var animationAlreadyInUse = function (className) { return className.includes(ANIMATION_CLASSNAME_FILENAME); };

export { ANIMATION_CLASSNAME_BASE, ANIMATION_CLASSNAME_FILENAME, ANIMATION_CLASSNAME_SELECTOR, addClassnameForVisible, animationAlreadyInUse, callWithVisible, fadeInAnimationClassname, getClassname, getClassnameType, getElementList };
//# sourceMappingURL=classManipulation.esm.js.map
